import { useHistory } from "react-router-dom"

const SuccessWrapper = () => {
  const router = useHistory()

  return (
    <div className="my-7">
      <button
        onClick={() => {
          router.push("/")
        }}
        type="submit"
        className="bg-yellowcolor w-full capitalize hover:bg-yellowcolor/90  text-black font-normal py-3 px-10 rounded-md"
      >
        <p>Log In Now</p>
      </button>
    </div>
  )
}

export default SuccessWrapper